export default __webpack_public_path__ + "static/media/안주3.1d38ea30.jpg";